<template>
<!-- 公告 -->
  <div class="bgs">
        <Header></Header>
        <div class="flex">
            <NavPersonal></NavPersonal>
        <div class="right">
             <el-container id="comment_tab">
            <el-main>
                <template>
                    <div class="el-page-header__content">消息中心</div>
                    <el-tabs>
                        <el-tab-pane class="el-btn-tabs" label="公告"></el-tab-pane>
                    </el-tabs>
                    <div class="comment_box" >
                        <template v-for="item in comments">
                            <div class="comment_info" >
                                <div @click="Go_Not_Det(item.id)" target="_blank">
                                    <span class="notice">公告</span>
                                    <span>{{item.title}}</span>
                                </div>
                                <span class="time">{{item.create_time}}</span>
                            </div>

                            <div class="infodetail" v-if="item.show == 1">
                                {{item.desc}}
                            </div>
                        </template>
                    </div>
                    <!--<div class="comment_more">-->
                        <!--<a class="more" href="javascript:;">查看更多</a>-->
                    <!--</div>-->
                </template>
            </el-main>
        </el-container>
        </div>
        </div>
        <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import NavPersonal from "../components/NavPersonal.vue";
import Axios from "axios"
export default {
    metaInfo(){
     return{
        title: '研究院公告_驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
    data(){
        return{
        id:0,
        msg:"公告列表"
        ,comments:[],
        first:0
        ,total:0
        ,per_page:0
        ,current_page:0
        ,last_page:0
        }
    },
  components: {
    Header,
    Footer,
    NavPersonal
  },
   methods:{
       Go_Not_Det(id){
      this.$router.push({path: '/NoticeDetails',query: { id:id }})
       },
      getComments:function (e) {
          Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/announcement/index",
      params: {
          content_type:this.content_type,status:this.status,page:this.page,limit:this.limit
      },
      headers: {
          token: localStorage.getItem("token"),
        },
    }).then((res) => {
        ////console.log(res);
      var temp = res.data.data.data;
      ////console.log(temp)
          for (var i = 0; i<temp.length;i++){
              temp[i]["show"] = 0;
          }
          this.comments = temp;
          this.total = res.data.total;
    });
        // Announcement({content_type:this.content_type,status:this.status,page:this.page,limit:this.limit}).then(res=>{
        //   var temp = res.data.data;
        //   for (var i = 0; i<temp.length;i++){
        //       temp[i]["show"] = 0;
        //   }
        //   this.comments = temp;
        //   this.total = res.data.total;
        // }).catch(res=>{
        //   ////console.log("评论列表获取失败");
        // })
      },
      show(v){
         if(v.show == 0){
             v.show = 1;
         }else {
             v.show = 0;
         }
      }
    },
    created(e){
      let id = this.$route.params.contentid;
      this.msg = id;
      this.id = id;

    },
    mounted(){
      this.getComments();
    }
}
</script>

<style scoped>
.bgs{
    background:#F5F7F9;
}
.main{
    width:200px;
    margin:0px;
}
 /deep/ .el-col-4 {
    width:200px !important;
}
.flex{
    display:flex;
    width:1200px;
    margin:20px auto;
}
.right{
    width:960px;
    background:#fff;
    margin-left:20px;
}
 /* 消息中心样式 */

  #comment_tab {
    background: #fff;
    padding: 0 20px;
    color: #333;
  }

  .comment_info {
      height: 54px;
      line-height: 54px;
      padding: 0 15px;
      display:flex;
      cursor: pointer;
      justify-content: space-between;
  }

  .comment_info:nth-last-child(1) {
    margin-bottom: 50px;
  }
  .el-page-header__content {
    font-size: 18px;
    color: #333;
    line-height: 18px;
    margin-bottom: 15px;
  }
  .notice {
    padding-right: 5px;
  }
  .time {
    float: right;
    color: #999;
    font-size: 12px;
  }
    .infodetail{
        padding: 15px;
        line-height: 25px;
    }
    .comment_info>div>span:first-child{
        color: #069ee9;
    }
  .comment_info>a>span:last-child{
      color: #333;
  }
   .comment_box>div:nth-child(even){
       background: #eee;
   }
    .infodetail{
        line-height: 28px;
        text-indent: 2rem;
        color: #666;
        font-size: 15px;
    }
</style>